import { render } from "./RumusListTemplate.vue?vue&type=template&id=befa2be6"
import script from "./RumusListTemplate.vue?vue&type=script&lang=js"
export * from "./RumusListTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__